import type Template from "./values/en.json";
import { LocaleLanguage } from "./values";

export * from "./values";

export type Values = typeof Template;

export function fetchValues(locale: LocaleLanguage): Promise<Values> {
  return import(`./values/${locale}.json`).then((module) => module.default);
}
